import {cn} from 'src/layouts/main-layout/app-sidebar/utils/utils'

function Skeleton({className, ...props}: React.ComponentProps<'div'>) {
  return <div data-slot='skeleton' className={cn('animate-pulse rounded-md bg-gray-200/30', className)} {...props} />
}

export {Skeleton}
